const isShowSnackBarModal = state => state.isShow
const statusSnackBarModal = state => state.status
const timeoutSnackBarModal = state => state.timeout
const messageSnackBarModal = state => state.message

export default {
  isShowSnackBarModal, statusSnackBarModal, timeoutSnackBarModal, messageSnackBarModal,
}
